export default "__VITE_ASSET__BmqbA8r___"